import { createSelector } from 'reselect';
import { hoveredDataLayerIdSelector, selectedBusLineSelector } from 'store/state/insightsContext/selectors';
import { MultiPolygon, Feature } from '@turf/helpers';
import { LayerProperties } from '../Insights/layersMappings';
import { ISchoolDataLayer } from 'utils/entities';
import { FeatureDescriptor } from 'utils/insightsFeatureTypes';
import { allSearchDataLayersDictionarySelector } from 'store/state/selectors/search';
import config from 'config';
import { getFetureCentroid } from 'utils/geo';
import { busRouteByIdsSelector } from 'store/state/domainData/selectors/busLine';
import _ from 'lodash';


export const activeDataLayerItemSelector = createSelector([
  hoveredDataLayerIdSelector,
  allSearchDataLayersDictionarySelector,
], (hoveredDataLayerId, dataLayersDictionary) => {
  if (!dataLayersDictionary[hoveredDataLayerId]) return null;

  return {
    locationPoint: getFetureCentroid(dataLayersDictionary[hoveredDataLayerId].geometry),
    ...dataLayersDictionary[hoveredDataLayerId],
  };
});

export const lastHoveredBusLineDataLayerItemSelector = createSelector([
  selectedBusLineSelector,
  allSearchDataLayersDictionarySelector,
  busRouteByIdsSelector,
], ({ busStationId: maybeBusStationId }, dataLayersDictionary, route) => {
  if (maybeBusStationId) {
    const busStation = dataLayersDictionary[maybeBusStationId];
    if (busStation && busStation.type === 'busStation' && route && route.length) {
      return {
        locationPoint: getFetureCentroid(busStation.geometry),
        ...busStation,
      };
    }
  }
  return null;
});

export const schoolsAdditionalFeaturesSelector = createSelector([
  activeDataLayerItemSelector,
], (activeItem): Feature<MultiPolygon, LayerProperties> => {
  if (activeItem && activeItem.type === 'school') {
    const item = activeItem as ISchoolDataLayer;
    if (item.zoneGeometry) {
      const registrationZone: Feature<MultiPolygon, LayerProperties> = {
        ...item.zoneGeometry,
        properties: {
          name: item.id,
          category: 'education',
          rtl: config.isRTL,
          featureType: FeatureDescriptor.ZoneGeometry,
        },
      };
      return registrationZone;
    }
  }

  return null;
});
